import { contactData } from '@/mocks/home';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function ContactSection() {
  const ref = useScrollReveal();
  return (
    <section id="contact" ref={ref} className="reveal-section py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              {contactData.title}
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
              {contactData.desc}
            </p>
          </div>

          <div className="bg-background-100 border border-background-200/70 rounded-lg p-6 md:p-8">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-8">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <div>
                  <div className="text-xs text-foreground-500 mb-0.5">投稿邮箱</div>
                  <div className="text-sm font-medium text-foreground-900">{contactData.email}</div>
                </div>
              </div>
              <div className="w-px h-10 bg-background-200 hidden sm:block"></div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                  <i className="ri-chat-3-line text-lg"></i>
                </div>
                <div>
                  <div className="text-xs text-foreground-500 mb-0.5">合作咨询</div>
                  <div className="text-sm font-medium text-foreground-900">QQ：{contactData.qq}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}